import React, {useState} from "react";
import ArrestSearch from "../../components/tools/arrest/_arrestSearch";
import SearchResults from "../../components/tools/arrest/_searchResultsArrest";
import {GetDarInfo_Query, PersonInfo, getDarInfoResponse} from "../../interfaces/getDarInfo_interface";
import {RunDarQuery} from "../../services/getDar.service";
import {Account} from "../../interfaces/auth_interface";
import {getUser, isArrestShow} from "../../services/auth.service";
import {useLocation} from "react-router-dom";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function Arrest() {
    let [darTbl, setDarTbl] = useState<PersonInfo[]>([])
    let [user, setUser] = useState<Account>(getUser())
    let [showPlate, setShowPlate] = useState<boolean>(false)
    let query = useQuery();
    let [noData, setNoData] = useState<boolean>(false)
    
    
    const SubmitSearch = async (params: any, dateType: string, andOrType: string, dropDowns: any) => {
        if(params.Plate && (params.Plate.includes("%") || params.Plate.includes("*") || params.Plate.includes("?") || params.Plate.includes("_")|| params?.Plate?.length > 10))
        {
            SubmitSearchConnection(params, dateType, andOrType, dropDowns)
        }
        else
        {
            let search_query: GetDarInfo_Query = {
                "QueryType": "\0",
                "Dept": user.Dept,
                "EmpID": user.EmpID,
                "DeptORI": user.DeptORI,
                "DateRange": params.showDate,
                "DateTypeValue": (dateType === "Entry Date") ? 0 : 1,
                "FromDate": params?.fromDate?.toLocaleString(),
                "ToDate": params?.toDate?.toLocaleString(),
                "SearchType": andOrType,
                "IndicatorOn": true,
                "TopArrestNumber": 0,
                "FNames": params.FirstName ? params.FirstName.split(',') : [],
                "MNames": params.MI ? params.MI.split(',') : [],
                "LNames": params.LastName ? params.LastName.split(',') : [],
                "DOBs": params.DOB ? params.DOB.split(',') : [],
                "SEX": dropDowns.Sex ? dropDowns.Sex : [],
                "Address": "",
                "Cities": dropDowns.City ? dropDowns.City : [],
                "States": dropDowns.State ? dropDowns.State : [],
                "Zip": "",
                "Statutes": dropDowns.Statute ? dropDowns.Statute : [],
                "Gang": [],
                "FBIs": params.FBI ? params.FBI.split(',') : [],
                "SBIs": params.SBI ? params.SBI.split(',') : [],
                "DLNos": params.DL ? params.DL.split(',') : [],
                "PlateNos": params.Plate ? params.Plate.split(',') : [],
                "VINs": [],
                "AgencyArrested": dropDowns.AgencyArrested ? dropDowns.AgencyArrested : [],
                "PoliceStopDept": dropDowns.PoliceStopDept ? dropDowns.PoliceStopDept : [],
                "Indicators": dropDowns.Indicator ? dropDowns.Indicator : [],
                "Latitude": null,
                "Longitude": null,
                "Radius": 0,
                "ResidentCounty": dropDowns.ResidentCounty ? dropDowns.ResidentCounty : [],
                "ArrestedCounty": dropDowns.ArrestedCounty ? dropDowns.ArrestedCounty : [],
                "Arrest_Type": dropDowns.ArrestType ? dropDowns.ArrestType : [],
                "CaseNumbers": params.Case ? params.Case.split(',') : [],
                "SSN": params.SSN ? params.SSN?.split(',') : [],
                "PlaceOfBirth": dropDowns.PlaceOfBirth ? dropDowns.PlaceOfBirth : [],
                "AgeRangeStart": params.AgeRangeStart,
                "AgeRangeEnd": params.AgeRangeEnd,
                "FTSIDs": params.FTSID ? params.FTSID.split(',') : [],
            }
            let qRes:getDarInfoResponse = await RunDarQuery(search_query)
            setDarTbl([])
            setDarTbl(qRes.PersonList)
            if (qRes?.PersonList?.length === 0) {
                setNoData(true)
            }
            else {
                setNoData(false)
            }
        }
        
    }

    const SubmitSearchConnection = async (params: any, dateType: string, andOrType: string, dropDowns: any) => {
        let search_query: GetDarInfo_Query = {
            "QueryType": "V",
            "Dept": user.Dept,
            "EmpID": user.EmpID,
            "DeptORI": user.DeptORI,
            "DateRange": params.showDate,
            "DateTypeValue": (dateType === "Entry Date") ? 0 : 1,
            "FromDate": params.fromDate,
            "ToDate": params.toDate,
            "SearchType": andOrType,
            "IndicatorOn": true,
            "TopArrestNumber": 0,
            "FNames": params.FirstName ? params.FirstName.split(',') : [],
            "MNames": params.MI ? params.MI.split(',') : [],
            "LNames": params.LastName ? params.LastName.split(',') : [],
            "DOBs": params.DOB ? params.DOB.split(',') : [],
            "SEX": dropDowns.Sex ? dropDowns.Sex : [],
            "Address": "",
            "Cities": dropDowns.City ? dropDowns.City : [],
            "States": dropDowns.State ? dropDowns.State : [],
            "Zip": "",
            "Statutes": dropDowns.Statute ? dropDowns.Statute : [],
            "Gang": [],
            "FBIs": params.FBI ? params.FBI.split(',') : [],
            "SBIs": params.SBI ? params.SBI.split(',') : [],
            "DLNos": params.DL ? params.DL.split(',') : [],
            "PlateNos": params.Plate ? params.Plate.split(',') : [],
            "VINs": [],
            "AgencyArrested": dropDowns.AgencyArrested ? dropDowns.AgencyArrested : [],
            "PoliceStopDept": dropDowns.PoliceStopDept ? dropDowns.PoliceStopDept : [],
            "Indicators": dropDowns.Indicator ? dropDowns.Indicator : [],
            "Latitude": null,
            "Longitude": null,
            "Radius": 0,
            "ResidentCounty": dropDowns.ResidentCounty ? dropDowns.ResidentCounty : [],
            "ArrestedCounty": dropDowns.ArrestedCounty ? dropDowns.ArrestedCounty : [],
            "Arrest_Type": dropDowns.ArrestType ? dropDowns.ArrestType : [],
            "CaseNumbers": params.Case ? params.Case.split(',') : [],
            "SSN": params.SSN ? params.SSN?.split(',') : [],
            "PlaceOfBirth": dropDowns.PlaceOfBirth ? dropDowns.PlaceOfBirth : [],
            "AgeRangeStart": params.AgeRangeStart,
            "AgeRangeEnd": params.AgeRangeEnd,
            "FTSIDs": params.FTSID ? params.FTSID.split(',') : [],
        }
        let qRes:getDarInfoResponse = await RunDarQuery(search_query)
        setDarTbl([])
        setDarTbl(qRes.PersonList)
        if (qRes?.PersonList?.length === 0) {
            setNoData(true)
        }
        else {
            setNoData(false)
        }
        if(params.Plate && params.Plate.length !== 0)
        {
            setShowPlate(true)
        }
        else
        {
            setShowPlate(false)
        }
    }

    return (
        <div id="ToolsArrest">
            {isArrestShow()?
                <>
                    {query.get("personList") ?
                    <ArrestSearch SubmitSearch={SubmitSearchConnection} passedData={query.get("personList")} />
                    :
                    query.get("plateList") ?
                    <ArrestSearch SubmitSearch={SubmitSearchConnection} passedData={query.get("plateList")} />
                    :
                    <ArrestSearch SubmitSearch={SubmitSearch} />}
                    {!noData ? <SearchResults Persons={darTbl} showPlate={showPlate} /> : <div className="font-bold text-lg ml-5">NO Matching Records Found</div>}
                </>
            :<></>}
        </div>
    );
}

export default Arrest;